import { useMemo } from 'react'

/**
 * Custom hook to check if the current host matches a specific host
 * @param {string} host - The host to check against (should be one of the values from APP_HOSTNAMES)
 * @returns {boolean} - True if current host matches the provided host, false otherwise
 */
const useHost = host => {
  return useMemo(() => {
    if (!host) {
      return false
    }

    const currentHostname = window.location.hostname

    return currentHostname === host
  }, [host])
}

export default useHost
